/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { mFIGetBonusCouponsDetailsAsync } from '../actions/BonusItemDataActionExtension.g';
import { IMFIGetBonusCouponsDetailsResponse } from '../actions/BonusItemDataServiceEntities.g';

// tslint:disable-next-line: completed-docs
export class BonusCouponsInfoInput implements IActionInput {
    public bonusCoupon: string;
    constructor(bonusCoupon: string) {
        this.bonusCoupon = bonusCoupon;
    }
    public getCacheKey = () => `MFRMBonusCouponsInfoInput-${this.bonusCoupon}`;
    public getCacheObjectType = () => 'MFRMBonusCouponsInfoInput';
    public dataCacheType = (): CacheType => 'application';
}

export interface IMFRMBonusCouponsDetailData {
    couponsDetails: IMFIGetBonusCouponsDetailsResponse;
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new BonusCouponsInfoInput('');
};

export async function getAllBonusCouponsDetails(
    input: BonusCouponsInfoInput,
    ctx: IActionContext
): Promise<IMFRMBonusCouponsDetailData> {
    try {
        const result = await mFIGetBonusCouponsDetailsAsync({ callerContext: ctx }, input.bonusCoupon);
        if (result) {
            return {couponsDetails: result};
        }
    } catch (error) {
        ctx.telemetry.warning(JSON.stringify(error));
        ctx.telemetry.debug('Unable to get Bonus Coupons Details when get all coupons');
    }
    return {couponsDetails: {}};
}

export default createObservableDataAction({
    id : 'MFRMBonusCouponsInfo',
    action: <IAction<IMFRMBonusCouponsDetailData>>getAllBonusCouponsDetails,
    input: createInput
});
